import template from './net-sales-history-page.html';

export default {
  template,
  controller: 'NetSalesHistoryPageController'
};




// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/net-sales/components/net-sales-history-page/net-sales-history-page-component.js